import _ from 'lodash';
import { store } from '_/vuex/store';

export const fileTagTemplate = function fileTagTemplate(asset) {
    let defaultLocale = store.state.ui.defaultLocale.languageCode;
    const title = _.get(asset, `fields.title.${defaultLocale}`, '');
    return `<a href="${asset.fields.file_url}" title="${title}">${asset.fields.file_name}</a>`;
};
